import { MoreOutlined, PlusOutlined, UpOutlined } from "@ant-design/icons";
import { ToastService } from "@shared/lib/services";
import {
  IBriefInfluencerSearchRequestV2,
  IBriefInfluencerV2,
  IFieldConfig,
} from "@shared/lib/types/briefInfluencerV2";
import {
  Button,
  Divider,
  Dropdown,
  Flex,
  Form,
  Input,
  Modal,
  Popover,
  Row,
  Space,
  Spin,
} from "antd";
import { useEffect, useState } from "react";

import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";


import useBulkActions from "@entities/brief/lib/hooks/useBulkActions";
import SuggestInfluencerPricingForm from "@entities/brief/ui/SuggetInfluencerPricing";
import { AddCustomFieldsDataButton } from "@features/AddCustomFieldsDataButton";
import { AddToCampaignFromBrief } from "@features/AddtoCampaignFromBrief";
import { AddDeliverablesButton } from "@features/CampaignDeliverables/AddDeliverablesButton";
import { AssignPricingModalV2 } from "@features/assignPricingModal/AssignPricingModalV2";
import { BriefNotificationActionType } from "@shared/lib/types/brief";
import { Popconfirm } from "@shared/ui";
import SuggestCampaignFromBriefForm from "@shared/ui/InfluencerTable/SuggestCampaignFromBriefForm";
import AddToBucket from "@shared/ui/Modals/AddToBucket";
export function BriefAllActions({
  selectedRowKeys,
  setSelectedRowKeys,
  selectedRows,
  setSelectedRows,
  refetch,
  params,
  updateBriefInfluencers,
  visibleCustomFields,
  selectAll,
  uncheckList,
  setSelectAll,
  setUncheckList,
  totalCount,
  briefInfluencers,
}: {
  selectedRowKeys: React.Key[];
  setSelectedRowKeys: React.Dispatch<React.SetStateAction<React.Key[]>>;
  selectedRows: IBriefInfluencerV2[];
  setSelectedRows: React.Dispatch<React.SetStateAction<IBriefInfluencerV2[]>>;
  refetch?: () => void;
  params?: IBriefInfluencerSearchRequestV2;
  updateBriefInfluencers: (
    data: { id: string; briefInfluencer: IBriefInfluencerV2 }[]
  ) => void;
  visibleCustomFields: IFieldConfig[];
  selectAll?: boolean;
  uncheckList?: string[];
  setSelectAll?: (val: boolean) => void;
  setUncheckList?: (val: string[]) => void;
  totalCount?: number;
  briefInfluencers?: IBriefInfluencerV2[];
}) {
  const [declinePopoverVisible, setDeclinePopoverVisible] =
    useState<boolean>(false);
  const [declineType, setDeclineType] = useState<"creator" | "brand" | null>(
    null
  );
  const [form] = Form.useForm();

  const { briefId } = useBriefStore();

  const [isSuggestModalOpen, setSuggestModalOpen] = useState<boolean>(false);
  const [
    isSuggestInfluencerPricingModalOpen,
    setIsSuggestInfluencerPricingModalOpen,
  ] = useState<boolean>(false);
  const [openAddToCampaignProps, setOpenAddToCampaignProps] = useState<{
    open: boolean;
  }>({
    open: false,
  });

  const [bucketId, setselectedbuckedId] = useState<string>("");
  const [isBucketModalVisible, setBucketModalVissible] =
    useState<boolean>(false);

  const [pricingPocModalProps, setPricingPocModalProps] = useState<{
    visible: boolean;
    briefInfluencerId: string[];
    type: "assign" | "reassign" | "remove";
  }>({
    visible: false,
    briefInfluencerId: [],
    type: "assign",
  });

  const openPricingPocModal = (
    briefInfluencerId: string[] | string,
    type: "assign" | "reassign" | "remove"
  ) => {
    setPricingPocModalProps({
      visible: true,
      briefInfluencerId: Array.isArray(briefInfluencerId)
        ? briefInfluencerId
        : [briefInfluencerId],
      type,
    });
  };

  const {
    bulkActions,
    isBulkActions,
    isBulkActionsSuccess,
    bulkActionsError,
  } = useBulkActions();

  useEffect(() => {
    if (isBulkActionsSuccess) {
      ToastService.success("Action completed successfully");
      setDeclinePopoverVisible(false);
      setBucketModalVissible(false);
      setPricingPocModalProps({
        visible: false,
        briefInfluencerId: [],
        type: "assign",
      });
      setSelectedRowKeys([]);
      setSelectedRows([]);
      setSelectAll?.(false);
      setUncheckList?.([]);
      refetch?.();
    } else if (bulkActionsError) {
      ToastService.error(bulkActionsError?.message);
    }
  }, [isBulkActionsSuccess, bulkActionsError]);

  const handleCreatorDecline = (values: { reason: string }) => {
    bulkActions({
      briefId,
      actionType: BriefNotificationActionType.declineInfluencer,
      ids: selectedRowKeys as string[],
      notIncludeIds: uncheckList || [],
      isSelectAll: selectAll,
      filterParams: params || {},
      actionParams: {
        declineInfluencerParams: { reason: values.reason },
      },
    });
  };

  const handleBrandDecline = () => {
    bulkActions({
      briefId,
      actionType: BriefNotificationActionType.declineBrand,
      ids: selectedRowKeys as string[],
      notIncludeIds: uncheckList || [],
      isSelectAll: selectAll,
      filterParams: params || {},
      actionParams: {},
    });
  };

  const handleDeleteSelected = () => {
    bulkActions({
      briefId,
      actionType: BriefNotificationActionType.deleteInfluencer,
      ids: selectedRowKeys as string[],
      notIncludeIds: uncheckList || [],
      isSelectAll: selectAll,
      filterParams: params || {},
      actionParams: {},
    });
  };

  const handleAdd = (bucketId: string) => {
    bulkActions({
      briefId,
      actionType: BriefNotificationActionType.addInfluencersToBucket,
      ids: selectedRowKeys as string[],
      notIncludeIds: uncheckList || [],
      isSelectAll: selectAll,
      filterParams: params || {},
      actionParams: {
        addInfluencersToBucketParams: {
          bucketId: bucketId,
        },
      },
    });
  };

  const isReAssginOrRemoveVisible = selectAll || selectedRowKeys.length > 0;

  const effectiveCount =
    selectAll && totalCount
      ? totalCount - (uncheckList?.length || 0)
      : selectedRowKeys.length;

  return (
    <>
      {(selectAll || selectedRowKeys.length > 0) && (
        <>
          {/* <Button onClick={() => setSuggestModalOpen(true)}>
            Suggest in a campaign ({selectedRowKeys.length})
          </Button>
          <Button onClick={() => setIsSuggestInfluencerPricingModalOpen(true)}>
            Copy Influencers ({selectedRowKeys.length})
          </Button> */}

          <Popover
            open={declinePopoverVisible}
            onOpenChange={(visible) => {
              if (!visible) {
                setDeclinePopoverVisible(false);
              }
            }}
            trigger={[]}
            content={
              <div style={{ padding: "4px" }}>
                <Form
                  form={form}
                  onFinish={(values) => {
                    handleCreatorDecline(values);
                  }}
                >
                  <Form.Item
                    name="reason"
                    rules={[
                      {
                        required: true,
                        message: "Please enter reason to decline.",
                      },
                    ]}
                  >
                    <Input.TextArea
                      placeholder="Enter reason to decline..."
                      rows={3}
                      style={{ marginBottom: 8, width: 250 }}
                    />
                  </Form.Item>
                  <Flex justify="end" gap={8}>
                    <Form.Item>
                      <Button
                        size="small"
                        onClick={() => setDeclinePopoverVisible(false)}
                      >
                        Cancel
                      </Button>
                    </Form.Item>
                    <Form.Item>
                      <Button
                        size="small"
                        type="primary"
                        htmlType="submit"
                        loading={isBulkActions}
                      >
                        Confirm
                      </Button>
                    </Form.Item>
                  </Flex>
                </Form>
              </div>
            }
            title="Creator Declined"
          >
            <Dropdown
              trigger={["click"]}
              menu={{
                items: [
                  {
                    label: (
                      <span>Add to Bucket ({effectiveCount})</span>
                    ),
                    key: "add-to-bucket",
                    // disabled: selectedRowKeys.length > 100,
                    onClick: () => setBucketModalVissible(true),
                  },
                  {
                    label: (
                      <span>Add to Campaign ({effectiveCount})</span>
                    ),
                    key: "add-to-campaign",
                    onClick: () => setOpenAddToCampaignProps({ open: true }),
                  },
                  { type: "divider" },
                  {
                    label: <span>Creator Declined ({effectiveCount})</span>,
                    key: "creator-declined",
                    onClick: () => {
                      setDeclineType("creator");
                      form.resetFields();
                      setDeclinePopoverVisible(true);
                    },
                  },
                  {
                    label: <span>Brand Declined ({effectiveCount})</span>,
                    key: "brand-declined",
                    onClick: () => {
                      handleBrandDecline();
                    },
                  },
                  { type: "divider" },
                  {
                    label: (
                      <Popconfirm
                        title="Delete creators"
                        description={`Are you sure you want to delete ${effectiveCount} selected creator(s)? This action cannot be undone.`}
                        onConfirm={handleDeleteSelected}
                        okText="Delete"
                        cancelText="Cancel"
                        okButtonProps={{ danger: true, loading: isBulkActions }}
                      >
                        <span
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                          }}
                        >
                          Delete ({effectiveCount})
                        </span>
                      </Popconfirm>
                    ),
                    key: "delete",
                    danger: true,
                  },
                ],
              }}
            >
              <Button
                icon={<MoreOutlined />}
                loading={isBulkActions}
              />
            </Dropdown>
          </Popover>
          <AddCustomFieldsDataButton
            selectAll={selectAll}
            checkedList={selectedRowKeys as string[]}
            uncheckList={uncheckList}
            searchPayload={params || {}}
            totalCount={totalCount || selectedRowKeys.length}
            onSuccess={updateBriefInfluencers}
            visibleColumns={visibleCustomFields}
          />

          <Dropdown
            trigger={["click"]}
            placement="bottomRight"
            menu={{
              items: [
                ...[
                  {
                    label: "Send for Pricing",
                    key: "assign-pricing-poc",
                    onClick: () => {
                      openPricingPocModal(
                        selectedRowKeys as string[],
                        "assign"
                      );
                    },
                  },
                ],
                ...(isReAssginOrRemoveVisible
                  ? [
                      {
                        label: "Reallocate Pricing POC",
                        key: "reassign-pricing-poc",
                        onClick: () => {
                          openPricingPocModal(
                            selectedRowKeys as string[],
                            "reassign"
                          );
                        },
                      },
                      {
                        label: "Remove Pricing POC",
                        key: "remove-pricing-poc",
                        onClick: () => {
                          openPricingPocModal(
                            selectedRowKeys as string[],
                            "remove"
                          );
                        },
                      },
                    ]
                  : []),
              ],
            }}
          >
            <Button
              icon={<UpOutlined size={16} />}
              iconPosition="end"
              type="primary"
            >
              Pricing Actions
            </Button>
          </Dropdown>

          <AddDeliverablesButton
            selectAll={selectAll}
            searchPayload={params || {}}
            checkedList={selectedRowKeys as string[]}
            uncheckList={uncheckList}
            totalCount={totalCount}
            handleUpdateBriefInfluencer={updateBriefInfluencers}
            onSuccess={() => {
              setSelectedRowKeys([]);
              setSelectedRows([]);
            }}
            buttonProps={{
              children: `Add/Edit Deliverables (${effectiveCount})`,
            }}
          />
        </>
      )}
      <Modal
        destroyOnClose
        title={"Suggest selected influencers in a campaign"}
        open={isSuggestModalOpen}
        onCancel={() => {
          setSuggestModalOpen(false);
        }}
        footer={null}
        width={1000}
      >
        <SuggestCampaignFromBriefForm
          creators={selectedRows || []}
          onClose={() => {
            setSelectedRows([]);
            setSelectedRowKeys([]);
            setSuggestModalOpen(false);
          }}
        />
      </Modal>
      <Modal
        destroyOnClose
        title={"Copy selected influencers in a campaign"}
        open={isSuggestInfluencerPricingModalOpen}
        onCancel={() => {
          setIsSuggestInfluencerPricingModalOpen(false);
        }}
        footer={null}
        width={1000}
      >
        <SuggestInfluencerPricingForm
          briefInfluencerIds={selectedRowKeys.map((key) => key as string) || []}
          handleSuccess={() => {
            setSelectedRowKeys([]);
            setIsSuggestInfluencerPricingModalOpen(false);
            setSelectedRows([]);
          }}
          onClose={() => {
            setIsSuggestInfluencerPricingModalOpen(false);
          }}
        />
      </Modal>
      <Modal
        title="Add Influencer To Bucket"
        open={isBucketModalVisible}
        onCancel={() => setBucketModalVissible(false)}
        footer={
          <>
            <Divider style={{ margin: "8px 0" }} />
            <Space
              style={{
                padding: "0 8px 4px",
                width: "100%",
                justifyContent: "space-between",
              }}
            ></Space>
            {bucketId ? (
              <Row style={{ justifyContent: "center", padding: 10 }}>
                {isBulkActions ? (
                  <Spin style={{ width: 30, height: 30 }} />
                ) : (
                  <Button
                    onClick={async () => handleAdd(bucketId)}
                    icon={<PlusOutlined />}
                  >
                    Add to selected buckets
                  </Button>
                )}
              </Row>
            ) : null}
          </>
        }
        destroyOnClose
      >
        <AddToBucket
          bucketIds={[bucketId]}
          setselectedbuckedIds={(val) => setselectedbuckedId(typeof(val) === "string" ? val : val?.[0])}
        />
      </Modal>

      {/* Drawer for selecting/creating deliverables */}
      {/* <Drawer
        title="Select Deliverable"
        open={
          deliverableModalProps.visible &&
          deliverableModalProps.type === "create"
        }
        onClose={() => {
          setDeliverableModalProps({
            visible: false,
            type: "create",
            deliverableId: "",
            briefInfluencerIds: [],
          });
          setSelectedDeliverableForAttach(null);
        }}
        width={800}
        bodyStyle={{ padding: 0 }}
        destroyOnClose
        footer={
          <Flex
            justify="flex-end"
            style={{
              padding: "16px 24px",
              // borderTop: "1px solid #f0f0f0",
              position: "sticky",
              bottom: 0,
              background: "#fff",
              zIndex: 10,
            }}
          >
            <Button
              type="primary"
              disabled={!selectedDeliverableForAttach}
              title={
                selectedDeliverableForAttach
                  ? ""
                  : "Please select a deliverable."
              }
              loading={isAttaching}
              onClick={() => {
                if (selectedDeliverableForAttach) {
                  attachBriefDeliverable({
                    deliverableId: selectedDeliverableForAttach._id,
                    briefInfluencerIds:
                      deliverableModalProps.briefInfluencerIds || [],
                  });
                }
              }}
            >
              Attach
            </Button>
          </Flex>
        }
      >
        {deliverableModalProps.visible &&
          deliverableModalProps.type === "create" && (
            <CampaignDeliverables
              showTitle={false}
              // selectedDeliverableId={brief?.defaultDeliverableV2Id}
              isEditable={true}
              briefInfluencerIds={deliverableModalProps.briefInfluencerIds}
              onSelectedDeliverableChange={(deliverable) => {
                setSelectedDeliverableForAttach(
                  deliverable ? { _id: deliverable._id || "" } : null
                );
              }}
              onClose={() => {
                setDeliverableModalProps({
                  visible: false,
                  type: "create",
                  deliverableId: "",
                  briefInfluencerIds: [],
                });
                setSelectedDeliverableForAttach(null);
              }}
            />
          )}
      </Drawer> */}

      <AddToCampaignFromBrief
        briefId={briefId}
        isInAll={false}
        onClose={() => {
          setOpenAddToCampaignProps({ open: false });
        }}
        open={openAddToCampaignProps.open}
        selectedBriefInfluencers={selectedRowKeys as string[]}
        selectAll={selectAll || false}
        checkedList={selectedRowKeys as string[]}
        totalCount={totalCount || selectedRowKeys.length}
        uncheckList={uncheckList || []}
        searchPayload={params || {}}
      />

      <Modal
        title="Add Influencer To Bucket"
        open={isBucketModalVisible}
        onCancel={() => setBucketModalVissible(false)}
        footer={
          <>
            <Divider style={{ margin: "8px 0" }} />
            <Space
              style={{
                padding: "0 8px 4px",
                width: "100%",
                justifyContent: "space-between",
              }}
            ></Space>
            {bucketId ? (
              <Row style={{ justifyContent: "center", padding: 10 }}>
                {isBulkActions ? (
                  <Spin style={{ width: 30, height: 30 }} />
                ) : (
                  <Button
                    onClick={async () => handleAdd(bucketId)}
                    icon={<PlusOutlined />}
                  >
                    Add to selected bucket
                  </Button>
                )}
              </Row>
            ) : null}
          </>
        }
        destroyOnClose
      >
        <AddToBucket
          bucketIds={[bucketId]}
          setselectedbuckedIds={(val) => setselectedbuckedId(typeof(val) === "string" ? val : val?.[0])}
        />
      </Modal>

      <Modal
        open={pricingPocModalProps.visible}
        onCancel={() =>
          setPricingPocModalProps({
            visible: false,
            briefInfluencerId: [],
            type: "assign",
          })
        }
        footer={null}
        title={
          pricingPocModalProps.type === "assign"
            ? "Assign Pricing POC"
            : pricingPocModalProps.type === "reassign"
              ? "Reallocate Pricing POC"
              : "Remove Pricing POC"
        }
        destroyOnClose
        width={700}
      >
        {pricingPocModalProps.visible && (
          <AssignPricingModalV2
            briefInfluencerIds={pricingPocModalProps.briefInfluencerId}
            type={pricingPocModalProps.type}
            selectAll={selectAll}
            uncheckList={uncheckList}
            totalCount={totalCount}
            onClose={() =>
              setPricingPocModalProps({
                visible: false,
                briefInfluencerId: [],
                type: "assign",
              })
            }
            isLoading={isBulkActions}
            onConfirm={(data) => {
              if (pricingPocModalProps.type === "assign") {
                bulkActions({
                  briefId,
                  actionType: BriefNotificationActionType.assignPricingPoc,
                  ids: selectedRowKeys as string[],
                  notIncludeIds: uncheckList,
                  isSelectAll: selectAll,
                  filterParams: params || {},
                  actionParams: {
                    assignPricingPocParams: {
                      assignedToUserId: data.assignedToUserId,
                      briefId,
                      deadlineFrom: data.deadlineFrom,
                      deadlineTo: data.deadlineTo,
                      pricingOutreachTerms: data.pricingOutreachTerms,
                    },
                  },
                });
              } else if (pricingPocModalProps.type === "reassign") {
                bulkActions({
                  briefId,
                  actionType: BriefNotificationActionType.reallocatePricingPoc,
                  ids: selectedRowKeys as string[],
                  notIncludeIds: uncheckList,
                  isSelectAll: selectAll,
                  filterParams: params || {},
                  actionParams: {
                    reallocatePricingPocParams: {
                      reallocatedToUserId: data.assignedToUserId,
                      briefId,
                      deadlineFrom: data.deadlineFrom,
                      deadlineTo: data.deadlineTo,
                      pricingOutreachTerms: data.pricingOutreachTerms,
                    },
                  },
                });
              } else {
                bulkActions({
                  briefId,
                  actionType: BriefNotificationActionType.removePricingPoc,
                  ids: selectedRowKeys as string[],
                  notIncludeIds: uncheckList,
                  isSelectAll: selectAll,
                  filterParams: params || {},
                  actionParams: {
                    removePricingPocParams: {
                      briefId,
                    },
                  },
                });
              }
            }}
          />
        )}
      </Modal>
    </>
  );
}
